import { type CSSProperties, type FC, type ReactNode } from 'react';
import { V4 } from '../tokens';

// Aviso de ramp-down (operator_evacuated): el operador regresó temporalmente a este comercio
// a la versión anterior mientras se mejora la nueva. NO es un rechazo del comercio ni un kill
// total: es un movimiento del operador. Copy tranquilizador, sin acción de "volver" (no aplica:
// el latch es server-side). 100% inline styles V4.

const InfoIcon: ReactNode = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5M12 7.5h.01" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const noticeStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  background: V4.grayBlueLight,
  border: `1px solid ${V4.grayLight}`,
  borderRadius: 10,
  padding: '12px 14px',
  fontFamily: 'inherit',
};

export const EvacuatedNotice: FC = () => (
  <div style={noticeStyle} role="status">
    <span
      style={{
        width: 32,
        height: 32,
        borderRadius: 8,
        background: V4.white,
        color: V4.secondary,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {InfoIcon}
    </span>
    <span style={{ flex: 1, minWidth: 0 }}>
      <span style={{ display: 'block', fontSize: 13, fontWeight: 700, color: V4.primary }}>
        Volvimos temporalmente a la versión anterior
      </span>
      <span style={{ display: 'block', fontSize: 11.5, color: V4.grayUltraDark, marginTop: 2, lineHeight: 1.45 }}>
        Estamos mejorando la nueva versión. No perdiste nada: tu menú y tu información siguen intactos, y te la
        ofreceremos de nuevo pronto.
      </span>
    </span>
  </div>
);

export default EvacuatedNotice;
